// English strings for the reception remainders: lost card (PB-06-12), returning-visitor evidence
// (PB-06-04) and cancellation impact (PB-04-07). Arabic: ar-reception-gaps.ts.
export const enReceptionGaps = {
  // ------------------------------------------------------------ lost card (PB-06-12)
  'rg.lost.report': 'Report lost card',
  'rg.lost.title': 'Report card {number} lost',
  'rg.lost.body': 'The card is blocked from reuse and revocation of its access is requested. The visitor stays onsite; their departure is recorded separately.',
  'rg.lost.reason': 'What happened',
  'rg.lost.reasonHint': 'Required. Kept in the audit trail and the handover task.',
  'rg.lost.confirm': 'Mark card lost',
  'rg.lost.statusTitle': 'Lost card and access',
  'rg.lost.cards': 'Lost cards',
  'rg.lost.cardLine': 'Card {number} reported lost {when}',
  'rg.lost.revocation': 'Access revocation',
  'rg.lost.noCredentials': 'No logical access credential was issued for this visitor.',
  'rg.lost.credentialsHidden': 'Credential details are visible to people who handle access.',
  'rg.lost.revokeReason': 'Revocation requested: {reason}',
  'rg.lost.inQueue': 'Outcome unknown — waiting in the access recovery queue for an operator.',
  'rg.lost.replacement': 'Replacement access',
  'rg.replacement.allowed': 'A replacement credential may be requested.',
  'rg.replacement.restricted': 'Restricted: no replacement credential until the earlier access is confirmed ended.',
  'rg.replacement.escalated': 'Restricted and escalated: an operator must resolve the earlier revocation in the recovery queue first.',
  'rg.replacement.reason.prior_unresolved': 'The earlier credential’s revocation is pending or its outcome is unknown.',
  'rg.replacement.reason.credential_exists': 'A credential that may still give access is active or being issued.',
  'rg.lost.custodyNote': 'A replacement physical card can be handed over; it carries no access until a new credential is confirmed.',
  // ------------------------------------------------------------ returning visitor (PB-06-04)
  'rg.ret.title': 'Earlier evidence',
  'rg.ret.note': 'Shown for information only. The new visit is checked again against today’s rules; earlier checks never carry over.',
  'rg.ret.none': 'No identity or contractor evidence on record.',
  'rg.ret.identity': 'Identity',
  'rg.ret.contractor': 'Contractor documents',
  'rg.ret.expires': 'expires {date}',
  'rg.ret.noExpiry': 'no expiry date',
  'rg.ret.captured': 'captured {date}',
  'rg.ret.soon': 'Expiring means within {count} days.',
  'rg.ret.unknownType': 'Document',
  'rg.policy.soonDays': 'Returning visitor: evidence expiring within (days)',
  'rg.policy.soonDaysHint': 'Reception sees earlier identity and contractor documents ending within this many days as expiring soon. 0–365.',
  'rg.expiry.expired': 'Expired',
  'rg.expiry.expiring': 'Expiring soon',
  'rg.expiry.valid': 'Valid',
  'rg.expiry.no_expiry': 'No expiry',
  // ------------------------------------------------------------ cancellation impact (PB-04-07)
  'rg.cancel.impactTitle': 'Who is affected',
  'rg.cancel.onsite': 'Onsite now — stays onsite until a departure is observed',
  'rg.cancel.notOnsite': 'Not onsite',
  'rg.cancel.credentials': { one: '{count} credential will be revoked (requested, outcome tracked)', other: '{count} credentials will be revoked (requested, outcome tracked)' },
  'rg.cancel.noCredentials': 'No access credential',
  'rg.cancel.links': { one: '{count} visitor link stops working', other: '{count} visitor links stop working' },
  'rg.cancel.noLinks': 'No active visitor link',
  'rg.cancel.removed': 'Removed from the visit',
  'rg.cancel.onsiteWarning': { one: '{count} person is onsite. Cancelling does not record their departure; reception must still check them out.', other: '{count} people are onsite. Cancelling does not record their departure; reception must still check them out.' },
} as const;
